module.exports = __webpack_public_path__ + "static/media/KAT.99edaf31.jpg";